// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2232":"9085be7a531603781dc9","3682":"73c0619c400a174ec83c","5060":"9e1163e8d392f0488461","5627":"dd2e35958532670fa24d","5886":"15577b71c93665883db5","6828":"47f8ea9f858dc10c881c","7348":"9c727a958955632dd9fd","8008":"4b76a416331085fa76c2"}[chunkId] + ".js";
};